export default __webpack_public_path__ + "static/media/2.c823517a.jpg";